import Axios from "axios";
import { json } from "body-parser";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useAppContext } from "../../context/state";
import { storage, useRequest } from "../../utils";
var FormData = require("form-data");
var axios = require("axios");
var FormData = require("form-data");
// import "../../assets/css/plugins/forms/wizard.css";
import ScriptTag from "react-script-tag";

import utils from "../../components/toastify/toastify";

const editProfile = (props) => {
  // const myFile = props.location.query.item;
  const [new_password, set_new_password] = useState();

  let history = useHistory();

  const sendData = () => {
    var formData = new FormData();

    var $white = "#fff";
    $.blockUI({
      message:
        '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',

      // timeout: 2000, //unblock after 2 seconds
      overlayCSS: {
        backgroundColor: $white,
        opacity: 0.8,
        cursor: "wait",
      },
      css: {
        border: 0,
        padding: 0,
        backgroundColor: "transparent",
      },
    });
    formData.append("new_password", new_password);

    storage.load("token").then((res) => {
      if (!res) return Promise.reject();
      Axios.post("/change_user_password", formData, {
        headers: {
          "x-auth": res,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          utils.showAlert("پروفایل با موفقیت بروزرسانی شد.", "success");
          history.push("/dashboard/");

          $.unblockUI();
        })
        .catch((err) => {
          utils.showAlert("خطایی به وجود آمده است", "error");
          $.unblockUI();
        });
    });
  };

  return (
    <div className="AddProductContainer">
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">مسیر</h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">ویرایش پروفایل</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Wizard /> */}
      {/* <!-- Basic Inputs start --> */}
      <section id="basic-input">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">ویرایش پروفایل</h4>
              </div>

              <div class="card">
                {/* <div class="card-header">
                  <h4 class="card-title">ترم ها</h4>
                </div> */}
                <div class="card-content">
                  <div class="card-body">
                    <form action="#" class="contact-repeater">
                      <div data-repeater-list="contact">
                        <div
                          class="row justify-content-between"
                          data-repeater-item
                        >
                          <div class="col-md-6 col-12 form-group d-flex align-items-center">
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  marginBottom: "10px",
                                }}
                              >
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="رمز عبور"
                                  value={new_password}
                                  onChange={(e) =>
                                    set_new_password(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <div class="row">
                          <div class="col-md-6">
                            <fieldset>
                              <h6>افزودن فایل</h6>
                              <div class="input-group">
                                <div class="input-group-prepend"></div>
                                <div class="input-group">
                                  <div class="custom-file">
                                    <input
                                      type="file"
                                      class="custom-file-input"
                                      id="inputGroupFile02"
                                      onChange={(e) =>
                                        setFile(e.target.files[0])
                                      }
                                    />
                                    <label
                                      class="custom-file-label"
                                      for="inputGroupFile02"
                                      aria-describedby="inputGroupFileAddon02"
                                    >
                                      {file ? file.name : "انتخاب فایل"}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </fieldset>
                          </div>
                        </div> */}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <button
                onClick={() => {
                  sendData();
                  // add_file_function()
                  //   .then(() => {
                  //     history.push(
                  //       "/dashboard/files/" +
                  //         props.match.params.day_id +
                  //         "/days/" +
                  //         props.match.params.term_id +
                  //         "/terms/" +
                  //         props.match.params.product_id
                  //     );
                  //     $.unblockUI();
                  //   })
                  //   .catch(() => {
                  //     utils.showAlert("خطایی به وجود آمده است", "error");
                  //     $.unblockUI();
                  //   });
                }}
                style={{
                  marginTop: "-2rem",
                  marginRight: "25px",
                  width: "fit-content",
                }}
                type="button"
                class="btn btn-success mr-1 mb-1 "
              >
                ویرایش پروفایل
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Basic Inputs end --> */}
      {/* <Demo /> */}
    </div>
  );
};

export { editProfile };
